import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getLinks = async () => {
  const response = await api.get('/links');
  return response.data;
};

export const createLink = async (linkData, password) => {
  const response = await api.post('/links', linkData, {
    headers: {
      'x-admin-password': password,
    },
  });
  return response.data;
};

export const updateLink = async (id, linkData, password) => {
  const response = await api.put(`/links/${id}`, linkData, {
    headers: {
      'x-admin-password': password,
    },
  });
  return response.data;
};

export const deleteLink = async (id, password) => {
  await api.delete(`/links/${id}`, {
    headers: {
      'x-admin-password': password,
    },
  });
};

export default api;
